import { createContext, ReactNode } from 'react';

type TranslationProviderProps = {
    children: ReactNode;
    translate: (key: string, data: any) => string;
};

export const TranslationProvider = ({ children, translate }: TranslationProviderProps) => {
    return <TranslationContext.Provider value={{ translate }}>{children}</TranslationContext.Provider>;
};

type Provider = {
    translate: (key: string, data: any) => string;
};

const defaultContext: Provider = {
    translate: (_key: string, _data: any) => {
        throw new Error('Translate not implemented');
    },
};

export const TranslationContext = createContext<Provider>(defaultContext);
